'use client'

import React, { createContext, useContext, useState, ReactNode } from 'react'

type LocalizedSlug = {
  id: number
  attributes: {
    locale: string
    slug: string
  }
}

interface HeaderContextType {
  localizedSlugs: LocalizedSlug[]
  setLocalizedSlugs: (slugs: LocalizedSlug[]) => void
}

const HeaderContext = createContext<HeaderContextType | undefined>(undefined)

interface HeaderProviderProps {
  children: ReactNode
}

export const HeaderProvider = ({ children }: HeaderProviderProps) => {
  const [localizedSlugs, setLocalizedSlugs] = useState<LocalizedSlug[]>([])
  return <HeaderContext.Provider value={{ localizedSlugs, setLocalizedSlugs }}>{children}</HeaderContext.Provider>
}

export const useHeaderContext = () => {
  const context = useContext(HeaderContext)
  if (!context) {
    throw new Error('useHeaderContext must be used within a HeaderProvider')
  }
  return context
}

interface LocalizedSlugsProviderProps {
  localizations: LocalizedSlug[]
}

export const HandleLocalizations = ({ localizations }: LocalizedSlugsProviderProps) => {
  const { setLocalizedSlugs } = useHeaderContext()

  React.useEffect(() => {
    setLocalizedSlugs(localizations)
    return () => setLocalizedSlugs([])
  }, [localizations, setLocalizedSlugs])

  return null
}
